
import * as PageCommands from "@/assets/scripts/PageEditor/Commands";
// Dependencies
import { defineComponent, PropType } from "vue";
import { ComplexTableProperty, FormattedText, Property, Sort, SummaryParser, TableColumnState } from "@/assets/scripts/Page";
// Components
import TabularField from "./TabularField.vue";

export default defineComponent({
  name: "ComplexTableField",
  props: {
    property: {
      type: Object as PropType<ComplexTableProperty>,
      required: true
    }
  },
  emits: ["execute"],
  methods: {
    
    /**
     * Summarizes a row using a summary template.
     * @param summary
     *  The summary string template.
     * @param row
     *  The row.
     * @returns
     *  The summary.
     */
    summarize(summary: string, row: Property[]): FormattedText[] {
      return SummaryParser.parse(summary, row);
    },

    /**
     * Row collapse behavior.
     * @param id
     *  The row's id.
     */
    onCollapse(id: string) {
      // Determine collapse state
      let c = !this.property.collapsed.get(id);
      // Collapse
      let cmd = PageCommands.collapseComplexTablePropertyRow(this.property, id, c);
      this.$emit("execute", cmd);
    }

  },
  beforeCreate() {
    this.$options.components!.FieldGrid = require("./FieldGrid.vue").default;
  },
  components: { 
    TabularField
  }
});
